module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.8356/img/storefront-header-blobs.svg"